/**
 * Dashboard page — localization manifest.
 *
 * Every i18n key that DashboardView.vue renders is listed here so the
 * route-level prefetcher can batch-translate them in a single API call
 * before the component mounts.
 */
export const dashboardManifest: readonly string[] = [
  // Section-specific keys
  "dashboard.title",
  "dashboard.totalRevenue",
  "dashboard.activeLeakages",
  "dashboard.recoveredRevenue",
  "dashboard.riskScore",
  "dashboard.recentInsights",
  "dashboard.revenueOverview",
  "dashboard.allTime",
  "dashboard.mrr",
  "dashboard.revenueAtRisk",
  "dashboard.openLeakages",
  "dashboard.outOf100",
  "dashboard.trendTitle",
  "dashboard.leakageByCategory",
  "dashboard.topLeakages",
  "dashboard.issue",
  "dashboard.issues",
  "dashboard.viewAllLeakages",
  "dashboard.range.30",
  "dashboard.range.90",
  "dashboard.range.180",
  "dashboard.range.365",
  // Shared nav + common keys used on the page
  "nav.dashboard",
  "common.loading",
  "common.noData",
  "common.refresh",
  "common.export",
  "common.filter",
  "severity.critical",
  "severity.high",
  "severity.medium",
  "severity.low",
] as const;
